var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgArticle = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5 3a.5.5 0 0 1 .09.992L14.5 4h-11a.5.5 0 0 1-.09-.992L3.5 3h11ZM8.5 6h-5a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 .5-.5v-6a.5.5 0 0 0-.5-.5ZM8 7v5H4V7h4ZM14.5 8a.5.5 0 0 1 .09.992L14.5 9h-3a.5.5 0 0 1-.09-.992L11.5 8h3ZM14.5 10a.5.5 0 0 1 .09.992L14.5 11h-4a.5.5 0 0 1-.09-.992L10.5 10h4ZM14.5 12a.5.5 0 0 1 .09.992L14.5 13h-4a.5.5 0 0 1-.09-.992L10.5 12h4ZM14.5 14a.5.5 0 0 1 .09.992L14.5 15h-11a.5.5 0 0 1-.09-.992L3.5 14h11ZM14.5 16a.5.5 0 0 1 .09.992L14.5 17h-11a.5.5 0 0 1-.09-.992L3.5 16h11ZM14.5 18a.5.5 0 0 1 .09.992L14.5 19h-11a.5.5 0 0 1-.09-.992L3.5 18h11ZM19.5 1.5a.5.5 0 0 1 .492.41L20 2v3h1.5a.5.5 0 0 1 .492.41L22 5.5v15a1.5 1.5 0 0 1-2.993.144L19 20.5v-18h-1V4a.5.5 0 0 1-.41.492l-.09.008a.5.5 0 0 1-.492-.41L17 4V2a.5.5 0 0 1 .41-.492l.09-.008h2ZM21 6h-1v14.5a.5.5 0 0 0 .41.492l.09.008a.5.5 0 0 0 .492-.41L21 20.5V6Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5 24a3.5 3.5 0 0 1-3.495-3.308L0 20.5V.5A.5.5 0 0 1 .41.008L.5 0h17a.5.5 0 0 1 .492.41L18 .5v20a2.5 2.5 0 0 0 4.995.164L23 20.5V4h-3.5a.5.5 0 0 1-.492-.41L19 3.5a.5.5 0 0 1 .41-.492L19.5 3h4a.5.5 0 0 1 .492.41L24 3.5v17a3.5 3.5 0 0 1-3.308 3.495L20.5 24h-17ZM17 20.5V1H1v19.5a2.5 2.5 0 0 0 2.336 2.495L3.5 23h14.552l-.027-.025a3.49 3.49 0 0 1-1.02-2.283L17 20.5Z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArticle);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/article.86b65953b83a60d06ea730c99c792821.svg";